/*
  Testimonials/reviews section helper for the FireNet Reviews (Google) widget.

  - Adds the "Load more" behaviour the design calls for on grid layouts.
  - Re-mounts the widget when a section is re-rendered in the theme editor.

  The widget itself renders asynchronously (it fetches reviews first), so each
  section is watched until its cards appear.
*/
(function () {
  var WRAPPER_SELECTOR = '[data-firenet-reviews-wrapper]';
  var WATCH_TIMEOUT = 30000;

  function reviewCards(grid) {
    return Array.prototype.filter.call(grid.children, function (element) {
      return element.classList.contains('fnr-card');
    });
  }

  // Returns true once the widget has rendered and there is nothing left to do.
  function setupLoadMore(wrapper) {
    if (wrapper.dataset.loadMoreReady === 'true') return true;

    var grid = wrapper.querySelector('.fnr-grid');
    if (!grid) return false;

    var cards = reviewCards(grid);
    if (!cards.length) return false; // still showing the loading skeleton

    wrapper.dataset.loadMoreReady = 'true';

    var step = parseInt(wrapper.dataset.reviewsStep || '0', 10);
    if (!step || cards.length <= step) return true;

    var shown = step;
    var holder = document.createElement('div');
    holder.className = 'firenet-reviews__load-more-wrapper';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'firenet-reviews__load-more button button--primary';
    button.textContent = wrapper.dataset.loadMoreLabel || 'Load more';
    holder.appendChild(button);

    var root = wrapper.querySelector('.fnr-root') || grid;
    root.parentNode.insertBefore(holder, root.nextSibling);

    function render() {
      cards.forEach(function (card, index) {
        card.hidden = index >= shown;
      });
      button.hidden = shown >= cards.length;
    }

    button.addEventListener('click', function () {
      shown = Math.min(shown + step, cards.length);
      render();
      var firstNew = cards[shown - step];
      if (firstNew) firstNew.focus({ preventScroll: true });
    });

    render();
    return true;
  }

  function watch(wrapper) {
    if (wrapper.dataset.loadMoreWatching === 'true') return;
    if (setupLoadMore(wrapper)) return;

    wrapper.dataset.loadMoreWatching = 'true';

    var observer = new MutationObserver(function () {
      if (setupLoadMore(wrapper)) stop();
    });

    function stop() {
      observer.disconnect();
      delete wrapper.dataset.loadMoreWatching;
    }

    observer.observe(wrapper, { childList: true, subtree: true });
    setTimeout(stop, WATCH_TIMEOUT);
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll(WRAPPER_SELECTOR), watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.querySelector || !section.querySelector(WRAPPER_SELECTOR)) return;
    if (window.FireNetReviews && window.FireNetReviews.mountAll) {
      window.FireNetReviews.mountAll(section);
    }
    init(section);
  });
})();
